<template>
	<tr class="pool-row" :class="{'hover': isHovering}" @mouseenter="isHovering = true" @mouseleave="isHovering = false">
		<td>{{ pool.name }}</td>
		<td class="text-grey">{{ pool.description || '-' }}</td>
		<td class="text-center">
			<div class="flex justify-center gap-2">
				<router-link :to="{name: 'productsPoolsEdit', params: {id: pool.id}}">
					<vs-button
						icon="edit"
						size="small"
						color="primary"
						type="border"
					></vs-button>
				</router-link>
				<vs-button
					icon="delete_outline"
					size="small"
					color="danger"
					type="border"
					@click="deletePool"
				></vs-button>
			</div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'poolRow',
	props: {
		pool: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			isHovering: false
		}
	},
	methods: {
		deletePool() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: 'Pool verwijderen',
				text: `Weet je zeker dat je "${this.pool.name}" wilt verwijderen? Synchronisatie van de voorraad zal direct stoppen, de huidige voorraad van de gekoppelde EAN blijft zoals deze nu is.`,
				acceptText: 'Verwijderen',
				cancelText: 'Annuleren',
				accept: async () => {
					try {
						await this.$store.dispatch('poolsData/deletePool', this.pool.id);
						this.$vs.notify({
							title: 'Gelukt',
							text: 'Pool is verwijderd',
							color: 'success'
						});
						this.$emit('deleted');
					} catch (error) {
						this.$vs.notify({
							title: 'Oops',
							text: 'Pool kon niet worden verwijderd',
							color: 'danger'
						});
					}
				}
			});
		}
	}
}
</script>

<style scoped>
.pool-row {
	transition: background-color 0.2s;
}

.pool-row.hover {
	background-color: #f5f5f5;
}

.pool-row td {
	padding: 1rem;
	vertical-align: middle;
}

.pool-row td:last-child {
	text-align: right;
}

.flex {
	display: flex;
}

.justify-center {
	justify-content: center;
}

.gap-2 {
	gap: 0.5rem;
}
</style>
